module.exports = __webpack_public_path__ + "img/group-chat1.83526003.png";